import { Component } from 'preact';

export default class LazyBackground extends Component {

	state = {
		image: null
	}

	componentDidMount() {
		let self = this;
		let image = new Image();
		image.src = this.props.image;
		image.onload = function() {
			self.setState({ image: true })
			// var canvas = document.createElement('CANVAS');
			// var ctx = canvas.getContext('2d');
			// var dataURL;
			// canvas.height = this.naturalHeight;
			// canvas.width = this.naturalWidth;
			// ctx.drawImage(this, 0, 0);
			// dataURL = canvas.toDataURL();
			// self.setState({ image: dataURL });
		};
	}

	render() {
		let style;
		if(this.state.image) {
			style = {
				// backgroundImage: `url(${this.state.image})`
				backgroundImage: `url(${this.props.image})`
			}
		}
		return  (
			<div className="lazy-background background" >
				{
					this.state.image &&
					<div className="cover fill" style={style}></div>
				}
				{
					this.props.overlay &&
					<div className="overlay fill"></div>
				}
				{
					this.props.children &&
					this.props.children
				}
			</div>
		)
	}

}



// WEBPACK FOOTER //
// ./components/lazy-background/index.js